import {Component, OnInit, HostListener} from "@angular/core";
import {Router, ActivatedRoute} from "@angular/router";
import {BenefitService} from "../../service/benefit/benefit.service";
import {BenefitBoard} from "app/service/benefit/benefit";
import {Category} from "app/service/benefit/benefit";
import { AuthService } from "app/service/auth/auth.service";

@Component({
  selector: 'app-benefit-board',
  templateUrl: './benefit-board.component.html',
  styleUrls: ['./benefit-board.component.scss'],
  providers: [BenefitService, AuthService]
})
export class BenefitBoardComponent implements OnInit {
  boards: BenefitBoard[];
  constructor(private benefitService: BenefitService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private router: Router,) {
    this.getCategories();

    this.route.queryParams.subscribe(
      params => {
        this.category = params['category']  ? params['category'].split(',') : [];
        this.search   = params['search']    ? params['search']   : '';

        this.benefitService.gets(params['category'], this.search).subscribe(
          boards => {
            // console.log(boards)
            this.boards = boards
          }
        )
    })
  }

  isMobile: boolean = false;
  @HostListener('window:resize', ['$event']) onResize(event) {
    let isMobile = (event.target.innerWidth < 768);
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
    }
  }
  ngOnInit(): void {
    this.isMobile = (window.innerWidth < 768);
  }

  reload() {
    let url = this.router.url.split('?')[0];

    this.router.navigateByUrl(
      `${url}?page=1` +
      `${this.selectedCate.length ? `&category=${this.selectedCate}`: ''}` +
      `${this.search ? `&search=${this.search}`: ''}`
    );
  }

  category: number[];
  categories: Category[];
  getCategories() {
    this.benefitService.getCategories().subscribe(
      (categories) => {
        this.categories = categories.map(o => ({
          ...o,
          checked: this.category.findIndex(opt => opt == o.id) != -1
        }))
      }
    )
  }
  onCate() {
    this.category = this.selectedCate;
    this.reload();
  }
  get selectedCate() {
    return this.categories.filter(opt => opt.checked).map(opt => opt.id);
  }

  search: string;
  onSearch(term: string) {
    this.search = term;
    this.reload();
  }

  onCanUpdate(): boolean {
    return this.authService.isAdmin();
  }
}


// WEBPACK FOOTER //
// ./src/app/member/benefit-board/benefit-board.component.ts